import { gql } from "@apollo/client";

export const GET_PRICING_ANALYSIS = gql`
query GetAllPricinganalysisData($pageOptions: PageOptions) {
    getAllPricinganalysisData(pageOptions: $pageOptions){
    arcimedes_row_id
    product_type
    items {
        name
        link
    }
  }
}`

export const GET_PRICING_ANALYSIS_BY_PRODUCT_TYPE = gql`
query GetPricingAnalysisByProductType($productType: String) {
    getPricingAnalysisByProductType(product_type: $productType) {
      arcimedes_row_id
      product_type
      items {
        name
        link
      }
      buyer_pool
      qualifications
      recommendations
    }
}`

export const CREATE_OR_PRICING_ANALYSIS = gql`
mutation CreateOrUpdatePricingAnalysis($input: [PricingAnalysisInput]) {
    createOrUpdatePricingAnalysis(input: $input) {
      data {
        items {
            name
            link
        }
        arcimedes_row_id
        product_type
      }
    }
}`